import React, { useEffect, useState } from 'react';
import { Form, FormInstance, TextInput } from 'blueprint-form';
import { Row, Col } from '../../../../grid';

import { CardBlock } from '../../card';
import { LoadingBlock } from '../../loading/progress';
import Modal from '../../modal';

import Button from '../../../molecules/button';
import Icon from '../../../atoms/icon';
import { faSave } from '@fortawesome/pro-solid-svg-icons';
import { ConfigComponent } from '../../../../libs/apps';
import { PostJSON, BaseResponse } from '../../../../libs/request';
import { useGetSettings } from '../../../../libs/settings';

interface EpxDischargeHTConfigFormProps {
  outreachPhoneAreaCode: string;
}

interface AreaCodeResponse extends BaseResponse {
  outreachPhoneAreaCode: string;
}

/**
 * High Touch Post-Discharge Config
 *
 * For adding, deleting, and creating area codes
 *
 * @returns JSX.Element
 */
export const EpxDischargeHTConfigForm: ConfigComponent = () => {
  const [areaCode, setAreaCode] = useState<string>('');
  const [isUpdating, setIsUpdating] = useState(false);
  const settings = useGetSettings({ appKey: 'epxdischargeht' }).settings;
  const form = new FormInstance<EpxDischargeHTConfigFormProps>({
    outreachPhoneAreaCode: ''
  });

  useEffect(() => {
    if (form && settings) {
      const values = JSON.parse(settings.values);
      form.setData(values);
    }
  }, [form, settings]);

  const saveAreaCode = (data: EpxDischargeHTConfigFormProps) => {
    setIsUpdating(true);
    PostJSON<AreaCodeResponse>({
      url: '/settings/edit/',
      params: {
        app: 'epxdischargeht',
        settings: {
          outreachPhoneAreaCode: data.outreachPhoneAreaCode
        }
      }
    }).then((response) => {
      setIsUpdating(false);
      if (response.status !== 'OK') {
        Modal.error({
          title: 'Error Saving Configuration',
          content: response.message
        });
        return;
      }
      Modal.success({
        title: 'Configuration Updated',
        content: 'The configuration has been updated successfully!'
      });
      const newAreaCode = (response as AreaCodeResponse).outreachPhoneAreaCode;
      if (newAreaCode) {
        setAreaCode(newAreaCode);
      }
      return;
    });
  };

  // Area code still loading
  if (areaCode === null) {
    return (
      <React.Fragment>
        <CardBlock>
          <LoadingBlock />
        </CardBlock>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <CardBlock>
        <Row>
          <Col sm={24}>
            <Form form={form} onSubmit={saveAreaCode}>
              <TextInput
                label="Outreach Phone Number Area Code"
                name="outreachPhoneAreaCode"
                placeholder="e.g. 314"
                required
              />
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            <Button
              intent="primary"
              icon={<Icon icon={faSave}></Icon>}
              loading={isUpdating}
              onClick={() => form.submit()}
            >
              Save Configuration
            </Button>
          </Col>
        </Row>
      </CardBlock>
    </React.Fragment>
  );
};
